import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=bf85c460&scoped=true"
import script from "./Specifications.vue?vue&type=script&lang=js"
export * from "./Specifications.vue?vue&type=script&lang=js"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=bf85c460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85c460",
  null
  
)

export default component.exports